import { Proposal } from "@engine/round/aggregate";
import { useLocalStorage } from "@uidotdev/usehooks";
import clsx from "clsx";
import { Link, useLocation } from "wouter";
export type ProposalLinkInfo = {
  proposal: Proposal | string;
  tab?: string;
  evaluator?: string;
};

export default function ProposalLink({
  proposal,
  tab,
  evaluator,
  children,
}: ProposalLinkInfo & {
  children: React.ReactNode;
}) {
  const [location] = useLocation();
  const [visitedProposals, setVisitedProposals] = useLocalStorage<string[]>(
    "visitedProposals",
    [],
  );

  const proposalId =
    typeof proposal === "string" ? proposal : proposal.shortname;

  const handleClick = () => {
    if (!visitedProposals.includes(proposalId)) {
      setVisitedProposals([...visitedProposals, proposalId]);
    }
  };

  const searchParams: { [k: string]: string } = {};

  if (typeof proposal === "string") {
    searchParams.proposal = proposal;
  } else {
    searchParams.proposal = proposal.shortname;
  }

  if (tab) {
    searchParams.tab = tab;
  }

  if (evaluator) {
    searchParams.evaluator = evaluator;
  }

  return (
    <Link
      className={clsx(
        "cursor-pointer",
        visitedProposals.includes(proposalId)
          ? "font-normal light:text-stone-800 dark:text-stone-200"
          : "font-bold light:text-stone-900 dark:text-stone-100",
      )}
      href={`${location}?${new URLSearchParams(searchParams).toString()}`}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
}
